import React from 'react'
import SectionBlock from '../../sectionBlock'
import CompanyBlock from './companyBlock'
import { getFeaturedCompanies } from '../apiClient'
import CompanyFeaturedLoader from '../../Loading/companyFeaturedLoader'
import { withTranslation } from '../../../i18n'
import { WithTranslation } from 'next-i18next'
import { ELanguage } from '@microfrontends/app-shell-v2'
import {buildVNWUrlFromPath} from "../../../helpers/urlBuilder";

type TSFeaturedCompaniesStates = {
	companies: any
	forceHide: boolean
}

type TFeaturedCompaniesProps = {
	companies: any
	languageCode: ELanguage
} & WithTranslation

const MAXIMUM_COMPANY_ITEMS = 6

class FeaturedCompanies extends React.Component<
	TFeaturedCompaniesProps,
	TSFeaturedCompaniesStates
> {
	constructor(props: any) {
		super(props)

		this.state = {
			companies: this.props.companies || [],
			forceHide: false
		}
	}

	async componentDidMount() {
		const { languageCode } = this.props

		if (!this.props.companies || this.props.companies.length === 0) {
			const companies = await getFeaturedCompanies(languageCode)
			if (companies.length > 0) {
				this.setState({
					companies: companies
				})
			} else {
				this.setState({ forceHide: true })
			}
		}
	}

	renderCompanyList() {
		const { companies } = this.state
		let companyList: any = []

		if (companies.length === 0) {
			for (let i = 0; i < MAXIMUM_COMPANY_ITEMS; i++) {
				companyList.push(
					<div
						key={i}
						className='column is-2-desktop is-4-tablet is-6-mobile'
					>
						{CompanyFeaturedLoader(i + 1)}
					</div>
				)
			}
		} else {
			const companyLength = companies.length

			companyList = companies
				.map((company, index) => (
					<CompanyBlock
						key={index}
						name={company.name}
						logo={company.logo}
						url={company.url}
						hasNewJobs={true}
						companyLength={companyLength}
					/>
				))
		}
		return companyList
	}

	render() {
		const { forceHide } = this.state
		if (forceHide) return null

		let sectionClass: string[] = [
			'sectionBlock_has-padding-touch sectionBlock_featured-company',
			// 'animated fadeIn take-1-second'
		]
		const titleText = this.props.t('Top Recruitment Companies')
		const bgImage = {
			backgroundImage: `url('${buildVNWUrlFromPath('/assets-page-container/images/feature-company-background.png')}')`
		}
		return (
			<SectionBlock
				title={titleText}
				sectionClass={sectionClass}
				sectionBlockStyle={bgImage}
			>
				<div className='featured-companies'>
					{this.renderCompanyList()}
				</div>
			</SectionBlock>
		)
	}
}

const FeaturedCompaniesCom = withTranslation('home')(FeaturedCompanies)
export default FeaturedCompaniesCom
